import * as React from 'react';
import { Row, Col, Button, Label } from 'reactstrap';
import { PulseLoader } from 'react-spinners';

export interface IAgencySubmitViewProps {
  wasErrorsUploadingLogo: () => boolean;
  loading: boolean;
  checkingCode: boolean;
  loadingMessage: string;
  invalidCode: boolean;
}

export class AgencySubmitView extends React.Component<IAgencySubmitViewProps, any> {
  constructor(props: IAgencySubmitViewProps) {
    super(props);
  }

  public render() {
    return (
      <Row>
        <Col md="7">
          <p className="required">*Required field</p>
        </Col>
        <Col md="5" className="text-center">
          {this.renderSubmitView()}
        </Col>
      </Row>
    );
  }

  public renderSubmitView() {
    return this.props.wasErrorsUploadingLogo() ?
      <Button type="submit" id="retryBTN" className="btn btn-outline float-right reupload btn-submit" >
        Retry to upload the images
      </Button> :
      <>
        <Label id="loadingText" className="text-center saving-text">{this.props.loadingMessage}</Label>
        <PulseLoader size={15} color={'#db8733'} loading={this.props.loading} />
        {this.props.loading ||
          <Button type="submit" id="submitBTN" className="btn btn-outline float-right btn-green-fill" disabled={this.props.invalidCode || this.props.checkingCode}>
            Submit
          </Button>}
      </>
  }
}

export default AgencySubmitView;
